// components/CollapsibleSection.jsx
import React from 'react';
import { motion, AnimatePresence } from "framer-motion";
import { HiChevronDown } from "react-icons/hi";

const CollapsibleSection = ({ id, title, children, isVisible, toggleVisibility, className = '' }) => {
  return (
    <div className={`${className} ${isVisible ? 'bg-cyan-700 rounded-md' : ''} overflow-hidden`} key={id}>
      <h3
        className="text-xl mb-1 cursor-pointer inline-flex items-center hover:underline decoration-amber-500"
        onClick={() => toggleVisibility(id)}
      >
      <motion.div 
        animate={{ rotate: isVisible ? 180 : 0 }}
        transition={{ duration: 0.3 }}
      >
        <HiChevronDown className="text-4xl text-amber-700 me-2" />
      </motion.div>
        {title}
      </h3>
      <AnimatePresence>
        {isVisible && (
          <motion.div 
            className=""
            key="visibleSection"
            layout
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ type: "spring", stiffness: 50, damping: 10 }}
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>
      
    </div>
  );
};

export default CollapsibleSection;
